import React from 'react'
import { Route,Redirect } from 'react-router-dom'

const MatchAuthenticated = ({
	path,
	location,
	isAuthenticated,
	willAuthenticate,	
	sideMenuVisible, // prototype side menu
	toggleSideMenuVisible, // prototype side menu
	component: Component,
}) =>
{
	if (isAuthenticated && !willAuthenticate){
		return( 
			<Route
				path={path}
				render={(props) => { 
					return <Component {...props} sideMenuVisible={sideMenuVisible} toggleSideMenuVisible={toggleSideMenuVisible} /> }
				}
			/>
	
		)
	} 	
	else if(!isAuthenticated && !willAuthenticate){
		return <Redirect to={{ pathname: '/login' }} />
	}
	else return null

} 
	
export default MatchAuthenticated
